export default "__VITE_ASSET__CMWOJCHq__";